import React from 'react';
import './FeatureText.sass';

import cx from 'classnames';

export default function FeatureText({center, reviews, header, headerComponent = 'h2', subheader, text, swapped, children}) {
  const HeaderComponent = headerComponent;

  return (
    <div className={cx("feature-text", center && "feature-text--center", reviews && "feature-text--reviews")}>
      {(subheader && !swapped) && <p className="feature-text__subheader">{subheader}</p>}
      <HeaderComponent className="feature-text__header">{header}</HeaderComponent>
      {(subheader && swapped) && <p className="feature-text__subheader">{subheader}</p>}
      {text && <p className="feature-text__content">{text}</p>}

      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/featureText/FeatureText.js